/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid = FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidOptions);
    }

    return {};
}

